export default __webpack_public_path__ + "static/media/athinaLoader.abbd2591.gif";